import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { WordpressRetrieveService } from '../../wordpress-retrieve.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

@Component({
  standalone: true,
  selector: 'app-feature',
  templateUrl: './feature.component.html',
  styleUrls: ['./feature.component.css'],
  imports: [
    CommonModule
  ]
})
export class FeatureComponent implements OnInit {
  feature: any;
  @Input() id?: String;
  
  constructor(private service: WordpressRetrieveService, private sanitizer: DomSanitizer, private route: ActivatedRoute) {
    this.feature = null;
    this.id = "67";
  }

  ngOnChanges(): void {
    this.service.getPostById(this.id!).subscribe((result)=>{
      //console.log(result);
      this.feature = result;
    });
  }
                                                 
  ngOnInit(): void {
    //console.log(this.feature);
  }
}
